var _desc, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 338,
    viewBox: "0 0 425 338",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shuffle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(377 -465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shuffle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "matrix(1 0 0 -1 -377 751.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-377 515)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Play"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(-33 663)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Play"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(-33 465)",
    fill: "#FFFFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 99 0L 0 0L 0 39L 83 39L 280.5 236.5L 397 236.5L 397 197.5L 296.5 197.5L 99 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    fillRule: "evenodd",
    d: "M 0 0L 99 0L 174.052 75.0521L 146.552 102.552L 83 39L 0 39L 0 0ZM 206.656 162.656L 280.5 236.5L 397 236.5L 397 197.5L 296.5 197.5L 234.156 135.156L 206.656 162.656Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 81 70L 0 0L 0 140L 81 70Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.114b32e30369a916ea69eb0ba2439be8.svg";
export { ForwardRef as ReactComponent };